export * from './lib/entry-components/educational-content/educational-content.component';
export * from './lib/smart.module';
